import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/src/locale/pt';
import '@fortawesome/fontawesome-free/css/all.css';
import { lightTheme, darkTheme } from '@/themes/defaultTheme';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    dark: true,
    themes: {
      light: lightTheme,
      dark: darkTheme
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: { iconfont: 'fa' },
});
